"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CTA_BUTTON_ROOT = exports.CTA_BUTTON_BUTTON = void 0;
const CTA_BUTTON_ROOT = exports.CTA_BUTTON_ROOT = 'cta-button-root';
const CTA_BUTTON_BUTTON = exports.CTA_BUTTON_BUTTON = 'cta-button-button';
